export const ANALYTICS_CHANNEL = 'postOffice';
export const ANALYTICS_SOURCE = 'post-office-frontend';
